export const gitCommit = '00411441'
